(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valeri-lymphoria"] && !Shopify.designMode) return;
  try {
    
function setupValeriLanding() {
  document.querySelectorAll('[data-valeri-landing]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const menu = root.querySelector('[data-valeri-menu]');
    const nav = root.querySelector('.valeri-nav');
    const sticky = root.querySelector('[data-valeri-sticky]');
    const hero = root.querySelector('.valeri-hero');
    const closeMenu = () => { nav.classList.remove('is-open'); menu.setAttribute('aria-expanded', 'false'); };
    menu.addEventListener('click', () => { const open = !nav.classList.contains('is-open'); nav.classList.toggle('is-open', open); menu.setAttribute('aria-expanded', String(open)); });
    nav.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
    root.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });
    const updateSticky = () => { if (root.isConnected) sticky.hidden = hero.getBoundingClientRect().bottom > 0; };
    const scrollContainer = root.closest('.page-wrapper') || window;
    scrollContainer.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
    root.querySelectorAll('select[name="id"]').forEach(select => select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const price = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(Number(option.dataset.price) / 100);
      root.querySelectorAll('[data-valeri-price]').forEach(el => { el.textContent = price; });
    }));
    const nativeForm = root.querySelector('.valeri-product-form');
    if (nativeForm) nativeForm.addEventListener('submit', event => {
      event.preventDefault();
      const releasit = document.getElementById('rsi_buy_now_button');
      if (releasit && !releasit.disabled) releasit.click();
      else root.querySelector('[data-valeri-buy-status]').hidden = false;
    });
  });
}
setupValeriLanding();
document.addEventListener('shopify:section:load', setupValeriLanding);

  } catch(e) { console.error(e); }
})();
})();
